import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { useSelector, useDispatch } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import Loader from "../../Loader";
import { useParams } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Button } from "@mui/material";
import { GetCustodianAccountTable } from "../../redux/Actions/userStatusService";
import BitgoCustAccount from "../../Modals/CustodianModals/BitgoCustAccount";

const CustodianTable = () => {
  const dispatch = useDispatch();
  const { custodianValue } = useParams();
  const [CustodianData, setCustodianData] = useState([]);
  const [open, setopen] = useState(false);
  const { custAccData, loading } = useSelector((state) => state.userStatus);

  useEffect(() => {
    if (custodianValue) dispatch(GetCustodianAccountTable(custodianValue));
  }, []);

  useEffect(() => {
    if (custAccData) {
      setCustodianData(custAccData);
    }
  }, [custAccData]);

  const columns = [
    {
      name: "sNO",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "15px" }}>{value}</div>;
        },
      },
    },
    {
      name: "Name",
      options: {
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "15px" }}>{value}</div>;
        },
      },
    },
    {
      name: "Email",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
      },
    },

    {
      name: "Group",
      options: {
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "15px" }}>{value}</div>;
        },
      },
    },

    {
      name: "Status",
      options: {
        filter: true,
        customBodyRender: (value) => {
          let color = "";
          let icon = null;

          if (value === "PENDING" || value === "pending") {
            color = "orange";
            icon = <HourglassEmptyIcon fontSize="small" />;
          } else if (
            value === "COMPLETED" ||
            value === "completed" ||
            value === "VERIFIED" ||
            value === "verified" ||
            value === "ACTIVE" ||
            value === "active"
          ) {
            color = "green";
            icon = <CheckCircleIcon fontSize="small" />;
          } else if (
            value === "FAILED" ||
            value === "failed" ||
            value === "REJECTED" ||
            value === "rejected"
          ) {
            color = "red";
            icon = <CancelIcon fontSize="small" />;
          }

          return (
            <div
              style={{
                marginLeft: "15px",
                color: color,
                display: "flex",
                alignItems: "center",
              }}
            >
              {icon}{" "}
              <span style={{ marginLeft: "5px", fontSize: "12px" }}>
                {value}
              </span>
            </div>
          );
        },
      },
    },
  ];
  const uppercaseColumns = ["Name", "Group", "Status"];
  const data = CustodianData?.map((item, index) => {
    const { name, email, group, status } = item;
    const transformedName = uppercaseColumns.includes("Name")
      ? name?.toUpperCase()
      : name;
    const transformedGroup = uppercaseColumns.includes("Group")
      ? group?.toUpperCase()
      : group;
    const transformedStatus = uppercaseColumns.includes("Status")
      ? status?.toUpperCase()
      : status;

    return [
      index + 1,
      transformedName,
      email,
      transformedGroup,
      transformedStatus,
    ];
  });
  const options = {
    filter: true,
    responsive: "standard",
    selectableRows: false,
    rowsPerPage: 8,
  };
  const theme = createTheme();
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {loading ? (
          <Loader />
        ) : (
          <div style={{ marginTop: "20px", width: "100%" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setopen(true);
              }}
              style={{ marginLeft: "20px", marginBottom: "10px" }}
            >
              CREATE NEW CLIENT ACCOUNT
            </Button>
            <MUIDataTable
              data={data}
              options={options}
              columns={columns}
              style={{
                width: "1300px",
                marginLeft: "200px",
              }}
            />
          </div>
        )}
        <BitgoCustAccount open={open} setopen={setopen} />
      </ThemeProvider>
    </>
  );
};

export default CustodianTable;
